import React from 'react'

const Item=()=> {
  return (
<>
<div>
<ul>
      <h1 className='mb-1 font-bold'> Resources</h1>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Industry and tools</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Use cases</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Blog</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Online events</a></li>
      
      

    </ul>
</div>
<div>
<ul>
      <h1 className='mb-1 font-bold'> Product</h1>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Drag and Dump</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Easy Content</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Blog</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Online events</a></li>
      
      

    </ul>
</div>

<div>
<ul>
      <h1 className='mb-1 font-bold'> Company</h1>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>About us</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>diversity inclusion</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>online community</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>customer stories</a></li>
      
      

    </ul>
</div>
<div>
<ul>
      <h1 className='mb-1 font-bold'> Support</h1>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Tutorial guides</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Documentation</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>Blog</a></li>
   <li> <a href='/' className='text-ray-400 hover:text-[#0d2e4e] duration-300 text-sm cursor-pointer'>webinar</a></li>
      
      

    </ul>
</div>



</>
  )
}

export default Item